// extracted by mini-css-extract-plugin
export default {"content":"Question_content__7FNgE","radio":"Question_radio__3RHf5","question":"Question_question__gxpFC","submit-answer":"Question_submit-answer__Kdx2o"};